import type { InputTokens } from './types';

export const input: InputTokens = {
  radii: {
    default: '12px',
  },
};
